import { BalanceStore } from './types';

export type UploadGateReason = 'inactive' | 'noMinutes' | 'paused' | 'whiteLabel' | null;

export type UploadGate = {
  canUpload: boolean;
  reason: UploadGateReason;
};

export type UploadGateState = Pick<
  BalanceStore,
  | 'hasActiveSubscription'
  | 'hasCanceledSubscription'
  | 'hasEnterprisePlan'
  | 'hasExpiredSubscription'
  | 'hasMinutes'
  | 'hasPastDueSubscription'
  | 'hasPausedSubscription'
  | 'hasTrialPlan'
  | 'hasUnpaidSubscription'
>;

export const getUploadGate = (state: UploadGateState, isWhiteLabel: boolean): UploadGate => {
  const {
    hasActiveSubscription,
    hasCanceledSubscription,
    hasEnterprisePlan,
    hasExpiredSubscription,
    hasMinutes,
    hasPastDueSubscription,
    hasPausedSubscription,
    hasTrialPlan,
    hasUnpaidSubscription,
  } = state;

  if (isWhiteLabel && !hasActiveSubscription) {
    return { canUpload: false, reason: 'whiteLabel' };
  }

  if (hasPausedSubscription) {
    return { canUpload: false, reason: 'paused' };
  }

  const isInactiveStatus =
    hasExpiredSubscription || hasCanceledSubscription || hasPastDueSubscription || hasUnpaidSubscription;

  if (isInactiveStatus) {
    return { canUpload: false, reason: 'inactive' };
  }

  const hasCredits = (hasActiveSubscription && hasMinutes) || hasEnterprisePlan || (hasTrialPlan && hasMinutes);

  if (!hasCredits) {
    return { canUpload: false, reason: 'noMinutes' };
  }

  return { canUpload: true, reason: null };
};
